import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";

import {
  fieldAlertMessage,
  fieldAlertTitle,
  playFieldAlertBeep,
} from "./dashboardFieldAlerts";
import "./DashboardFieldAlertsKpi.css";

function DashboardFieldAlertPopup({ event, soundEnabled, soundId, volume, t }) {
  useEffect(() => {
    if (!event || !soundEnabled) return;
    playFieldAlertBeep({ soundId, volume });
  }, [event, soundEnabled, soundId, volume]);

  if (!event) return null;

  return (
    <div className="dashboard-field-alert-popup" role="status" aria-live="polite">
      <div className="dashboard-field-alert-popup__card">
        <p className="dashboard-field-alert-popup__kind">
          {t("Notificação")} · {fieldAlertTitle(event.type, t)}
        </p>
        <p className="dashboard-field-alert-popup__text">
          {fieldAlertMessage(event, t)}
        </p>
      </div>
    </div>
  );
}

export default withTranslation()(DashboardFieldAlertPopup);
